import React from 'react';

import { Board } from './pieces/lazy-loaded-board';

export default function LazyLoaded(): React.JSX.Element {
	return <Board />;
}
